<template>
  <v-card tile>
    <v-card-title>
      <v-img
        max-height=250
        contain
        src="../assets/invoke.png"
      />
    </v-card-title>
    <v-card-text>
      <p>
        When invoking the planning REST API we invoke the API Gateway with a problem description and a JSON Web Token to invoke the method.
        The API Gateway will check if the token is valid and if the function is allowed to be invoked by the invoker. There can be many reasons why
        the function is not allowed to be invoked, too many invocations, black listed IP addresses etc. The Lambda function is where the planning
        logic resides. Next the severless Lambda function is invoked and the result is returned.
      </p>
      <br>
      <v-flex xs12>
        <v-text-field
          label="API Gateway"
          disabled
          v-model="url"
          persistent-hint
          hint="Endpoint for API gateway"
        ></v-text-field>
      </v-flex>
      <br>
      <v-flex xs12>
        <v-textarea
          persistent-hint
          label="Problem description"
          readonly
          disabled
          :value="JSON.stringify(problem)"
        />
      </v-flex>
      <v-flex xs12>
        <v-btn
          :loading="loading"
          :disabled="!hasToken"
          block
          @click="submit"
        >
          INVOKE PLANNING {{hasToken ? '' : 'BUT FIRST GET A TOKEN'}}
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          label="Result"
          readonly
          v-model="solution"
        />
      </v-flex>
    </v-card-text>
  </v-card>
</template>
<script>
var request = require("request");

import { mapGetters } from "vuex"

export default {
  data: () => ({
    url: 'https://2k0hw7bz43.execute-api.eu-central-1.amazonaws.com/dev/plan',
    loading: false,
    problem: {
      name: 'Puzzle 001',
      demand: {
        children: [
          {
            age: 1,
            days: [2, 3, 4]
          }
        ]
      }
    },
    solution: ''
  }),
  computed: {
    ...mapGetters("token", ["token", "hasToken"])
  },
  methods: {
    submit: function () {
      let self = this
      self.loading = true
      var options = {
        method: 'POST',
        url: this.url,
        headers: {
          'Content-Type': 'application/json',
          Authorization: this.token,
        },
        body: this.problem,
        json: true
      }


      request(options, function (error, response, body) {
        if (error) {
          console.log(error, response, body)

        } else {
          self.solution = JSON.stringify(body)
        }
        self.loading = false
      });
    }
  }
};
</script>
